module.exports = __webpack_public_path__ + "wxMicroService/img/result_icon.830af6a0.png";